module.exports = __webpack_public_path__ + "media/images/dashboard/rumble-banner-bg-e256c78d204b99357e710d35b64ea4e0.png";